import React from 'react'
import { SectionHeader } from '../Headlines'

export function Team({ content }) {
  return (
    <section className='inset padded no-border'>
      <SectionHeader title="Team" topBorder />
      <div className='vstack padded'>
        <p className='center narrow'>{content.team.text}</p>

        <div className="team-grid">
          {content.team.items.map((member, index) => (
            <div className="team-member" key={index}>
              <div className="team-member-image">
                <img 
                  src={`assets/expeditionspage/team/${member.name.toLowerCase().split(' ').join('-').replace('.', '')}.jpg`} 
                  alt={member.name} 
                />
              </div>
              <p>{member.name}<br /><span>{member.role}</span></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
} 